exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-bootom-button[data-v-173a6a5c] {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  border-top: 1px solid #e8e8e8;\n  padding: 10px 16px;\n  text-align: right;\n  left: 0;\n  background: #fff;\n  border-radius: 0 0 2px 2px;\n}\n", ""]);

// exports
